export enum PERSONS_ORDER_COLUMN {
  NAME = 'NAME',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}
